import {
  REQUEST_GET_ORDER_SUCCESS, REQUEST_GET_ORDER_FAILED, CURR_ORDER_CLEAR,
  CURR_ORDER_SET
} from "../actions/curr_order_actions";


const initialState = {
  order: {}
}

export const currOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_GET_ORDER_SUCCESS: {
      return {
        order: action.payload
      }
    }
    case REQUEST_GET_ORDER_FAILED: {
      return {
        order: {}
      }
    }
    case CURR_ORDER_SET: {
      return {
        order: action.payload
      }
    }
    case CURR_ORDER_CLEAR: {
      return {
        order: {}
      }
    }
    default:
      return state;
  }
}
